import { BodySmallTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledText = styled.span`
  ${BodySmallTypography};
  color: ${({ theme }) => theme.colors.BLACK_900};
`
